module.exports = __webpack_public_path__ + "static/media/moon.a58d4155.svg";